import Component from "@ember/component"
import { action, computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import { handleError } from "cc-frontend/error-handling"

export default class AdminDetail extends Component {
  @service("ember-store") store

  @service rpc

  @computed("model.id", "model.type")
  get ccUrl() {
    let modelType = get(this, "model.type")
    let model = get(this, "model")
    let origin = window.location.origin
    if (modelType === "course") {
      let planbookId = get(this, "model.relationships.planbook.data.id")
      return `${origin}/planbooks/${planbookId}/planner/timeline?courseIds=%B%22${model.id}%22%5D&isFilteringClasses=true`
    } else if (modelType === "planbook") {
      return `${origin}/planbooks/${model.id}/planner/week`
    } else if (modelType === "user") {
      let userId = get(this, "model.id")
      return `${origin}/users/${userId}`
    } else if (modelType === "group") {
      let userId = get(this, "model.id")
      return `${origin}/groups/${userId}`
    } else {
      return null
    }
  }

  @computed("model.id", "model.type")
  get mLabUrl() {
    let collectionNames = {
      planbook: "planbooks_",
      course: "courses_",
      user: "users",
      "card-stack": "card_stacks",
      "class-website": "class_websites_",
      "rotation-calendar": "rotation_calendar",
      group: "group_",
      "fisal-group": "fiscal_group",
    }
    let collectionName = collectionNames[get(this, "model.type")]
    return `https://mlab.com/clusters/rs-ds139038/databases/octoplan-wt-2/collections/${collectionName}?_id=${get(
      this,
      "model.id"
    )}`
  }

  @action
  rollback(model) {
    // ask if the user wants to rollback
    swal({
      title: "Are you sure you want to rollback?",
      type: "warning",
      showCancelButton: true,
    })
      .then(() => {
        let id = `${get(model, "type")}:${get(model, "id")}:${get(model, "attributes.version")}`
        get(this, "rpc")["ROLLBACK"](id)
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }
}
